import { io } from 'socket.io-client';

const socket = io("https://my-school-backend-z51g.onrender.com", {
  transports: ['polling', 'websocket'],
  withCredentials: false,
  autoConnect: true,
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 1000
});

export default socket;
